import { blobToExcel, exportExcel, ExportHeaders } from '@/utils';
import { request } from 'ice';
import { AxiosRequestConfig } from 'axios';
import { Message } from '@fpxfd/next';

// 导出
export const doExport = async ({ data, url, method, ...lastprops }: ExportConfig, name: string) => {
  const values = typeof data === 'function' ? data() : data;
  const res = await request({
    url,
    responseType: 'blob',
    method: method || 'POST',
    ...lastprops,
    data: values,
    headers: {
      zoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  });
  blobToExcel(res, `${name}`);
};

// 导出
export const doXslxExport = async (
  { data, url, method }: AxiosRequestConfig,
  fileName: string,
  headers: ExportHeaders,
  transform,
) => {
  const res = await request({
    url,
    method: method || 'POST',
    data,
    headers: {
      zoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
    },
  });
  if (!res.length) return;
  // 数据处理 --- 字典的处理
  const result = transform ? transform(res) : { ...res };
  // 导出
  exportExcel(headers, result, `${fileName}.xlsx`);
};
